import { render, staticRenderFns } from "./ClubRooms.vue?vue&type=template&id=45745172&scoped=true"
import script from "./ClubRooms.vue?vue&type=script&lang=js"
export * from "./ClubRooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45745172",
  null
  
)

export default component.exports